import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const UserFormatter = ({ row }) => {
    const created_by = row.created_by;

    if (!created_by || !created_by.first_name) {
        return <Typography variant="caption">---</Typography>;
    }

    return (
        <Typography variant="caption">
            {created_by.first_name} {created_by.last_name}
        </Typography>
    );
};

UserFormatter.propTypes = {
    row: PropTypes.object,
};

export default UserFormatter;
